import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer'
import Container from "react-bootstrap/Container";
import {useEffect, useState} from "react";
import Form from 'react-bootstrap/Form'
import Button from "react-bootstrap/Button";
import classes from "./Shitster.module.css";
import Alert from 'react-bootstrap/Alert';
import axios from "axios";
import Stack from "react-bootstrap/Stack";
import QRCode from "qrcode"

function QRCodeImage({ url, style }) {
  const urlPromise = QRCode.toDataURL(url);
  return <Image src={urlPromise} style={style} />;
}

const ShitsterPdf = (data) => {

  const ROWS = 6
  const COLS = 4

  const dataModel = () => {
    const pages = []

    let currentCard = 0
    let currentPage = []
    let currentRow = []

    for (const track of data.data) {
      // If new page, reset and add new one to the list
      if (currentCard % (ROWS  * COLS) === 0) {
        currentPage = []
        pages.push(currentPage)
      }

      // If new row, reset and add new one to the list
      if (currentCard % (COLS) === 0) {
        currentRow = []
        currentPage.push(currentRow)
      }

      const cardModel = {
        year: track.track.album.release_date,
        artist: track.track.artists[0].name,
        title: track.track.name,
        url: "https://open.spotify.com/track/" + track.track.id
      }
      currentRow.push(cardModel)
      currentCard ++
    }
    return pages
  }

  return (<Document>
    {dataModel().map(function(pageData, i){
      return <>
        <Page size="A4" key={i}>
          {pageData.map(function(rowData, rowCount){
            return rowData.map(function(card, colCount){
              return <View key={colCount}>
                <QRCodeImage url={card.url} style={[{width: "100px", position: "absolute", top: 15 + rowCount * 135 + "px", left: 15 + colCount * 135 + "px"}]} />
              </View>
            })
          })}
        </Page>
        <Page size="A4" key={i}>
          {pageData.map(function(rowData, rowCount){
            return rowData.map(function(card, colCount){
              return <View key={colCount}>
                <Text style={[{textAlign: "center", fontSize: 12, width: "100px", position: "absolute", top: 15 + rowCount * 135 + "px", right: 15 + colCount * 135 + "px"}]} >{card.title}</Text>
                <Text style={[{textAlign: "center", fontSize: 12, width: "100px", position: "absolute", top: 60 + rowCount * 135 + "px", right: 15 + colCount * 135 + "px"}]} >{card.artist}</Text>
                <Text style={[{textAlign: "center", fontSize: 12, width: "100px", position: "absolute", top: 90 + rowCount * 135 + "px", right: 15 + colCount * 135 + "px"}]} >{card.year}</Text>
              </View>
            })
          })}
        </Page>
      </>
    })}
  </Document>)
}

// https://open.spotify.com/playlist/17ZYVhab7ciVvgBNxcXpvV?si=e3b99845b41d49c7

const ShitsterGenerate = ({token}) => {

  const EXPRESSION = /spotify\..+\/([0-9a-zA-Z.]+)\/([0-9a-zA-Z.]+).*$/
  const [data, setData] = useState([])
  const [playlistLink, setPlaylistLink] = useState("")
  const [playlistName, setPlaylistName] = useState("")
  const [errorText, setErrorText] = useState("")
  const [allReceived, setAllReceived] = useState(false)

  const generate = () => {
    setErrorText("")
    setAllReceived(false)
    setData([])

    if (!playlistLink) {
      setErrorText("Please paste playlist link :)")
      return
    }

    // Extract useful part from link
    const match = playlistLink.match(EXPRESSION)
    if (match && match.length === 3) {
      if (match[1] !== "playlist") {
        setErrorText("Only playlist links are supported :(")
      } else {
        // Fetch data
        getNext("https://api.spotify.com/v1/playlists/" + match[2])
      }
    } else {
      setErrorText("Invalid playlist link :(")
    }
  }

  const getNext = (url) => {
    axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(data => {
      if (data.data.name) setPlaylistName(data.data.name)

      const tracks = data.data.tracks ? data.data.tracks : data.data
      setData(d => {
        return d.concat(tracks.items)
      })
      if (tracks.next) {
        getNext(tracks.next)
      } else setAllReceived(true)
    }).catch(function (e) {
      console.log("Failed to get list data")
      console.log(e)
    })
  }

  return (
    <Container>
      <Stack gap={3}>
        <Form.Control type="text" placeholder="Paste Spotify playlist link" onChange={d => setPlaylistLink(d.target.value)}/>
        <Button className={classes.StackButton} onClick={generate}>Generate!</Button>
        {allReceived && (data && <PDFDownloadLink document={<ShitsterPdf data={data}/>} fileName={"shitster_" + playlistName + ".pdf"}>
          {({blob, url, loading, error}) => (loading ? <Alert>Loading document...</Alert> : <Button variant={"danger"} className={classes.StackButton}>Download now!</Button>)}
        </PDFDownloadLink>)}
        {errorText && <Alert variant={'warning'}>Error: {errorText}</Alert>}
      </Stack>
    </Container>
  )
}

export default ShitsterGenerate
